import AdaptiveImage from "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "e763d54a54921d465c4e2bd9e897c876.png",
    width: 313,
    height: 177
});